import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import AddressChangeFields from "./AddressChangeFields";
import { ADDRESS_FIELDS } from "./ticketFormConfig";

// "עדכון כתובת האתר" dialog - the customer enters the correct site address
const AddressChangeDialog = (props) => {
  const { addressDialogOpen, addressFieldErrors, handleAddressDialogCancel, handleAddressDialogSave } = props;

  return (
    <Dialog
      open={addressDialogOpen}
      onClose={handleAddressDialogCancel}
      dir="rtl"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>עדכון כתובת האתר</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          מה הכתובת הנכונה?
        </DialogContentText>
        <AddressChangeFields {...props} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddressDialogCancel} color="primary">
          ביטול
        </Button>
        <Button
          onClick={handleAddressDialogSave}
          color="primary"
          variant="contained"
          disabled={ADDRESS_FIELDS.some(
            ({ key }) => !!addressFieldErrors[key] && addressFieldErrors[key] !== "שדה חובה"
          )}
        >
          שמירה
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddressChangeDialog;
